module.exports = __webpack_public_path__ + "img/logo.b695b5bd.png";